import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogData } from './exceljs-confirm-dialog-data.interface';

@Component({
  selector: 'red-exceljs-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './exceljs-confirm-dialog.component.html',
  styleUrls: ['./exceljs-confirm-dialog.component.scss'],
})
export class ExceljsConfirmDialogComponent {
  constructor(public dialogRef: MatDialogRef<ExceljsConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
  dimiss(): void {
    this.dialogRef.close(false);
  }
}
